export const SectionHead = ({ eyebrow, title, text, light = false, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
    <div>
      <p className={`text-xs font-semibold uppercase tracking-[0.2em] mb-3 ${light ? "text-[#E2A100]" : "text-[#B87F00]"}`}>{eyebrow}</p>
      <h2 className={`font-display text-2xl sm:text-3xl font-bold tracking-tight ${light ? "text-white" : "text-[#202A35]"}`}>{title}</h2>
      {text && <p className={`mt-3 text-sm sm:text-base max-w-lg ${light ? "text-white/70" : "text-[#202A35]/70"}`}>{text}</p>}
    </div>
    {action}
  </div>
);
